import { LegalShell, DataOwnershipBlock, SecureBadge } from "@/components/legal/LegalShell";
import { ShieldCheck, Users, ScrollText, KeyRound, Lock, Download } from "lucide-react";

const JK = { fontFamily: "'Plus Jakarta Sans', sans-serif" };

const PILLARS = [
  { icon: ShieldCheck, title: "Tenant Data Isolation", desc: "Every database query is filtered by tenant. One organization can never see another's data — enforced server-side, not just in the UI." },
  { icon: Users, title: "Role-Based Access Control", desc: "Admin, Manager and Agent roles scope what each user can see and do. Agents only access their assigned accounts." },
  { icon: ScrollText, title: "Audit Logs", desc: "Logins, account changes, settlement approvals/rejections, payments and user changes are recorded with timestamp, user and tenant." },
  { icon: KeyRound, title: "Secure Authentication", desc: "Salted password hashing (no plain-text), rate-limited logins with lockout, session management and logout from all devices." },
  { icon: Lock, title: "Encrypted Data Transfer", desc: "All traffic is served over HTTPS/TLS with secure, httponly cookies." },
  { icon: Download, title: "Data Export Capability", desc: "Export your accounts, activities, follow-ups, settlements and reports as CSV or Excel at any time." },
];

export default function Security() {
  return (
    <LegalShell title="Security & Data Protection">
      <div className="flex flex-col items-start gap-4">
        <SecureBadge />
        <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-950" style={JK}>Your Data. Your Control.</h2>
        <p>
          RecoverOS is built as a secure, multi-tenant SaaS platform for receivables, collections and settlement
          management. Security and strict tenant isolation are foundational to how the product is designed.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-px bg-slate-200 border border-slate-200" data-testid="security-pillars">
        {PILLARS.map((p) => (
          <div key={p.title} className="bg-white p-6">
            <div className="h-10 w-10 bg-[#0B3D91]/10 flex items-center justify-center">
              <p.icon className="h-5 w-5 text-[#0B3D91]" />
            </div>
            <h3 className="mt-4 font-bold text-slate-950" style={JK}>{p.title}</h3>
            <p className="mt-1.5 text-sm text-slate-600">{p.desc}</p>
          </div>
        ))}
      </div>

      <DataOwnershipBlock />

      <p className="text-sm text-slate-500">
        For security questions or to report a concern, contact{" "}
        <a href="mailto:support@recoveros.in" className="text-[#0B3D91] font-semibold">support@recoveros.in</a>.
        See also our <a href="/privacy-policy" className="text-[#0B3D91] font-semibold underline">Privacy Policy</a> and{" "}
        <a href="/terms-of-service" className="text-[#0B3D91] font-semibold underline">Terms of Service</a>.
      </p>
    </LegalShell>
  );
}
